module.exports = __webpack_public_path__ + "static/media/pBREW.9ff7f47b.png";